import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ClaimService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-asset',
  templateUrl: './claim-asset.page.html',
  standalone: false,
})
export class ClaimAssetPage {
  constructor(private claimSvc: ClaimService) {}

  readonly claim$ = this.claimSvc.getClaim();
}
